import React, {FC} from 'react';

import {PriceWithUsd} from 'components/currency/price-with-usd';
import {calculateProductUnitPrice} from 'utils/quotes/calculator';

interface ProductUnitPriceProps {
    price: number;
    commissionMultiplier: number;
    exchangeRate?: number | null;
};

export const ProductUnitPrice: FC<ProductUnitPriceProps> = React.memo(({price, exchangeRate}) => {
    return <PriceWithUsd brlAmount={calculateProductUnitPrice(price)} exchangeRate={exchangeRate} />;
});
